import React, { useState } from 'react';
import useProxyAuth from '../hooks/useProxyAuth';
import UPPage from '../components/UPPage';
import AgreementsApprove from '../components/AgreementsApprove';
import { LinearProgress } from '@mui/material';
import { ErrorCodes, ResponseErrorBodyDataNotSignedAgreement } from '../types';

const CreateUserForm = React.lazy(() =>
  import('./../components/CreateUserForm')
);

/**
 * Main Page
 */
export default function() {
  const [resend, setResend] = useState(0);
  const { isLogged, response } = useProxyAuth(resend);

  if (isLogged || isLogged === undefined) {
    return <LinearProgress color="primary" />;
  }

  let content;
  if (
    response &&
    response.error &&
    response.error.code === ErrorCodes.NOT_SIGNED_AGREEMENT
  ) {
    content = (
      <AgreementsApprove
        agreementsUnsigned={
          (response.error.data as ResponseErrorBodyDataNotSignedAgreement)
            .agreements
        }
        onSuccess={() => setResend(resend => resend + 1)}
      />
    );
  } else {
    content = (
      <>
        <CreateUserForm typeLogin="" />
      </>
    );
  }

  return <UPPage>{content}</UPPage>;
}
